import { AppDownload } from "components/AppDownload";
import { ContentContainer } from "components/Container";
import { useTranslation } from "react-i18next";

export const DownloadCta = () => {
  const { t } = useTranslation();

  return (
    <section className="mt-20 lg:mt-36">
      <ContentContainer>
        <div className="flex flex-col items-center text-center">
          <h2 className="title-text-style">{t("download_cta_title")}</h2>
          <div className="mt-8">
            <AppDownload inlineButtons sectionId="download-cta" />
          </div>
          <p className="text-sm text-textSecondaryGrey mt-3">
            {t("hero.download_note")}
          </p>
        </div>
      </ContentContainer>
    </section>
  );
};
